import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

export function withAuth(Component) {
  return function ProtectedRoute(props) {
    const navigate = useNavigate();
    const accessToken = Cookies.get('accessToken');

    useEffect(() => {
      if (!accessToken) {
        navigate('/login');
      }
    }, [accessToken, navigate]);

    if (!accessToken) {
      return null;
    }

    return <Component {...props} />;
  };
}

export function withoutAuth(Component) {
  return function PublicRoute(props) {
    const navigate = useNavigate();
    const accessToken = Cookies.get('accessToken');

    useEffect(() => {
      if (accessToken) {
        navigate('/');
      }
    }, [accessToken, navigate]);

    if (accessToken) {
      return null;
    }

    return <Component {...props} />;
  };
}

export function checkAuth() {
  const accessToken = Cookies.get('accessToken');
  return !!accessToken;
}